<div class="sticky-container">
  <div class="bg-img"></div>
  <div class="preview-container sayso-preview-settings">
    <mat-tab-group onsip-tab-group-custom-width onsip-tab-group-primary onsip-no-chevron-tab-group>
      <mat-tab>
        <ng-template mat-tab-label>
          {{ "ONSIP_I18N.WEB" | translate }}
        </ng-template>
        <ng-container *ngTemplateOutlet="web"></ng-container>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          {{ "ONSIP_I18N.MOBILE" | translate }}
        </ng-template>
        <ng-container *ngTemplateOutlet="mobile"></ng-container>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>

<ng-template #mobile>
  <div class="container">
    <onsip-team-settings-mobile-preview></onsip-team-settings-mobile-preview>
  </div>
</ng-template>

<ng-template #web>
  <div class="container">
    <onsip-team-settings-web-preview></onsip-team-settings-web-preview>
  </div>
</ng-template>
